







import { scaleLinear } from 'd3'

export default {
  props: {
    width: Number,
    height: Number,
    x: {
      type: Number,
      required: true
    },
    y: {
      type: Number,
      required: true
    }
  },

  data: function() {
    return {
      yRange: [-5, 5]
    }
  },

  computed: {
    svgStyle() {
      return `width: ${this.width}px; height: ${this.height}px;`
    },
    yValues() {
      return scaleLinear().range([this.height, 0]).domain(this.yRange).clamp(true)
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./app/javascript/components/evaluation_graph/d3_dot.vue